// @ts-ignore
import Keycloak from 'Keycloak';

export function withTokenUpdate(
  keycloak: Keycloak,
  action: () => Promise<any>,
  onError?: () => any,
): Promise<any> {
  return keycloak
    .updateToken(30)
    .then(function () {
      return action();
    })
    .catch(onError ?? ((e: Error) => Promise.reject(e)));
}

export function createAuthHeader(keycloakToken: string) {
  return {
    Authorization: `Bearer ${keycloakToken}`,
  };
}
